var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSegmented(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-112 -59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m129 61.766v-2.532c0-.13-.28-.234-.628-.234h-15.744c-.349 0-.628.104-.628.234v2.532c0 .13.28.234.628.234h15.744c.349 0 .628-.104.628-.234zm-3 4v-2.532c0-.13-.127-.234-.285-.234h-13.43c-.158 0-.285.104-.285.234v2.532c0 .13.127.234.285.234h13.43c.155 0 .285-.104.285-.234z",
    fill: "#38474d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 73.766c0 .13.184.234.414.234h13.172c.23 0 .414-.104.414-.234v-2.532c0-.13-.184-.234-.414-.234h-13.168c-.23 0-.414.104-.414.234v2.532zm0-4c0 .13.21.234.473.234h15.054c.263 0 .473-.104.473-.234v-2.532c0-.13-.21-.234-.473-.234h-15.05c-.262 0-.472.104-.472.234v2.532z",
    fill: "#fc6d52"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 27,
    rx: 2,
    stroke: "#ececec",
    width: 105,
    x: 32.5,
    y: 53.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmented);
export default __webpack_public_path__ + "static/media/segmented.fe7b6a37a3e4bccdee4a8e1397f2df5a.svg";
export { ForwardRef as ReactComponent };